import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://socialbunkr.in';
const SITE_NAME = 'Social Bunkr';
const DEFAULT_DESCRIPTION =
  'Book affordable PG beds with 3 meals a day across India. Short stays in Bangalore, Hyderabad, Mumbai, Pune and more - ₹300 to ₹500/night, all-inclusive.';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

interface SeoProps {
  title?: string;
  description?: string;
  path?: string;
  noindex?: boolean;
  jsonLd?: object | object[];
  ogImage?: string;
}

const Seo: React.FC<SeoProps> = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '/',
  noindex = false,
  jsonLd,
  ogImage = DEFAULT_OG_IMAGE,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - PG Short Stays with 3 Meals, ₹300–₹500/night`;
  const cleanPath = path === '/' ? '/' : `/${path.replace(/^\/+|\/+$/g, '').toLowerCase()}`;
  const canonical = `${SITE_URL}${cleanPath === '/' ? '' : cleanPath}`;

  const jsonLdBlocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical || SITE_URL} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={canonical || SITE_URL} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical || SITE_URL} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />

      {jsonLdBlocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
